class DropdownAlternative extends HTMLElement {
  constructor() {
    super();
    this.activeDropdown = null;
    this.activeDropDownItem = null;
  }

  connectedCallback() {
    const dropDownList = this.querySelector('.collection__dropdown-tab-list');
    if (!dropDownList) return;

    const updatePositionDropdown = () => {
      if (!this.activeDropdown || !this.activeDropDownItem) return;

      const { left, bottom, width: dropdownWidth, height: dropdownHeight } = this.activeDropdown.getBoundingClientRect();
      const { left: containerLeft, top: containerTop, width: containerWidth } = this.getBoundingClientRect();
      const offsetLeft = left - containerLeft + this.scrollLeft;
      const offsetTop = bottom - containerTop + this.scrollTop;
      const { width: activeDropDownItemWidth } = this.activeDropDownItem.getBoundingClientRect();
      const activeDropDownContentWidth = this.activeDropDownItem.querySelector('.facets__list')?.clientWidth || 0;

      const topAdditionalHeight = window.innerWidth > 749 ? 26 : 34;

      Object.assign(this.activeDropDownItem.style, {
        position: 'absolute',
        top: `${offsetTop + dropdownHeight + topAdditionalHeight}px`,
        zIndex: 10,
        left: `${window.innerWidth > 750 ? Math.max(0,Math.min(offsetLeft - 16, containerWidth - activeDropDownContentWidth - 16 )): 0}px`,
        right: 'auto',
      });
    };

    dropDownList?.addEventListener('click', (event) => {
      const dropdown = event.target.closest('.collection__dropdown-tab-title');
      if (!dropdown) return;

      const currentOpenedDropDown = this.querySelector('.collection__dropdown-tab-title[open]');

      if (currentOpenedDropDown?.dataset.dropdownIndex === dropdown.dataset.dropdownIndex) {
        dropdown.removeAttribute('open');
        return;
      }

      if (currentOpenedDropDown) currentOpenedDropDown.removeAttribute('open');

      dropdown.setAttribute('open', '');

      const dropdownIndex = dropdown.dataset.dropdownIndex;
      const dropDownItem = this.querySelector(`.dropdown-item-${dropdownIndex}`);
      if (!dropDownItem) return;

      let { width: dropDownItemMinWidth } = dropdown.getBoundingClientRect();
      if (dropDownItemMinWidth < 110) dropDownItemMinWidth = 110;
      if (dropDownItemMinWidth > 150) dropDownItemMinWidth = 150;

      dropDownItem.style.minWidth = `${dropDownItemMinWidth}px`;

      this.activeDropdown = dropdown;
      this.activeDropDownItem = dropDownItem;

      updatePositionDropdown();
    });

    dropDownList.addEventListener('scroll', updatePositionDropdown);
    window.addEventListener('resize', updatePositionDropdown);
  }
}

customElements.define('dropdown-alternative', DropdownAlternative);